// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const NotificationBell = registerClientReference(
    function() { throw new Error("Attempted to call NotificationBell() from the server but NotificationBell is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/components/notifications/notification-bell.tsx <module evaluation>",
    "NotificationBell",
);
